export default () => ({
  type: 'CLOSE_MODAL',
});
